module.exports = [{"Date":"2008-01-31","Close":1378.550049},{"Date":"2008-02-29","Close":1330.630005},{"Date":"2008-03-31","Close":1322.699951},{"Date":"2008-04-30","Close":1385.589966},{"Date":"2008-05-30","Close":1400.380005},{"Date":"2008-06-30","Close":1280},{"Date":"2008-07-31","Close":1267.380005},{"Date":"2008-08-29","Close":1282.829956},{"Date":"2008-09-30","Close":1166.359985},{"Date":"2008-10-31","Close":968.75},{"Date":"2008-11-28","Close":896.23999},{"Date":"2008-12-31","Close":903.25},{"Date":"2009-01-30","Close":825.880005},{"Date":"2009-02-27","Close":735.090027}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/gspc-20071231-20090228-monthly.json
// module id = 7570
// module chunks = 0